import React from 'react'

import { get, isNil } from 'lodash-es'

import { PRODUCT_TYPE } from '@lyrahealth-inc/shared-app-logic/src/features/common/constants/productType'
import { hasCHRTHighRisk } from '@lyrahealth-inc/shared-app-logic/src/features/highAlert/utils'
import { AssessmentType } from '@lyrahealth-inc/shared-app-logic/src/models/assessment/Assessment'
import { Outcome } from '@lyrahealth-inc/shared-app-logic/src/models/outcome/Outcome'

import styles from './outcomeChart.module.scss'
import colors from '../../../styles/_0colors'
import { getProductTypeColors, hasCustomColors } from '../../utils/productTypeColors'

const CustomDot: React.FC<CustomDotProps> = ({
  cx = 0,
  cy = 0,
  dataKey = '',
  fill = '#fff',
  fillNoValueEntries = false,
  index = 0,
  isActive = false,
  payload = {},
  stroke = colors.x_secondary_action,
  tooltipIndex = -1,
  productType,
  isAuroraTheme,
}) => {
  const dotRadius = 4
  const lineHeight = 440 - 55 + dotRadius - cy // 440 is the height of the chart. 55 is the height of the x axis labels.

  // Get colors based on product type
  const productColors = getProductTypeColors(productType, isAuroraTheme)
  const useCustomColors = hasCustomColors(productType, isAuroraTheme)
  const defaultStroke = useCustomColors ? productColors.primaryAction : stroke
  let fillColor = fill === '#fff' ? defaultStroke : fill
  const ourActive = isActive || tooltipIndex === index
  const noValue = fillNoValueEntries && isNil(get(payload, dataKey))
  const phqSelfHarm = dataKey.includes('PHQ') && get(payload, 'scores.PHQ-SELF-HARM')
  if (phqSelfHarm && phqSelfHarm > 0) fillColor = styles.x_alert
  if (dataKey.includes(AssessmentType.CHRT) && hasCHRTHighRisk(payload?.response_details)) fillColor = styles.x_alert

  return (
    <svg x={cx - dotRadius} y={cy - dotRadius} height={lineHeight} width={dotRadius * 2}>
      {ourActive && (
        <line
          x1={dotRadius}
          y1='0'
          x2={dotRadius}
          y2={lineHeight}
          strokeLinecap='round'
          stroke={fillColor}
          strokeWidth={'2'}
          data-test-id='CustomDot-activeLine'
        />
      )}
      {noValue ? (
        <line
          x1={dotRadius}
          y1='0'
          x2={dotRadius}
          y2={lineHeight}
          strokeLinecap='round'
          stroke={styles.x_light_gray_10}
          strokeWidth={String(dotRadius * 2)}
          data-test-id='CustomDot-noValueLine'
        />
      ) : (
        <circle cx={dotRadius} cy={dotRadius} r={dotRadius} fill={fillColor} data-test-id='CustomDot-valueCicle' />
      )}
    </svg>
  )
}

type CustomDotProps = {
  cx?: number
  cy?: number
  dataKey?: string
  fill?: string
  fillNoValueEntries?: boolean
  index?: number
  isActive?: boolean
  payload?: Outcome
  stroke?: string
  tooltipIndex?: number
  productType?: PRODUCT_TYPE
  isAuroraTheme?: boolean
}

export default CustomDot
